import { connect } from 'react-redux'
import CasesViewModal from './CasesViewModal'
import { getTroubleTicket, addTroubleTicketNote } from '../Cases.actions'
import { flow } from 'lodash'
import { reduxForm } from 'redux-form'

const formName = 'caseViewModal'

const stateToProps = ({ cases }, { caseItem }) => ({
  caseItem: cases.casesById[caseItem.id],
  initialValues: {
    caseId: caseItem.id,
  },
})

const dispatchToProps = {
  getTroubleTicket,
  addTroubleTicketNote,
}

export default flow(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(CasesViewModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesViewModal/CasesViewModal.container.js